// Modules
import React from 'react';
import store from '../store'
import * as actions from '../actions/user';
import {connect} from 'react-redux';
// Comps & Styling
import Main from './main';

export class Account extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            ...store.getState().user
        };
    }

    updateUserLocalStateData(event, key){
        this.setState({
            ...this.state,
            [key]: event.target.value});
    }
    updateAccount(e){
        e.preventDefault();

        let payload = {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            method: "PUT",
            body: JSON.stringify({
                uuid: this.state.uuid,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                gamertag: this.state.gamertag,
                password: this.state.password,
                email: this.state.email
            })
        };
        let localPayload = {
            uuid: this.state.uuid,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            gamertag: this.state.gamertag,
            password: this.state.password,
            email: this.state.email
        };

        store.dispatch(actions.updateAccountAsync(payload, localPayload));
    }
    deleteAccount(event){
        event.preventDefault();
        let payload = {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            method: "DELETE",
            body: JSON.stringify({
                uuid: this.state.uuid,
            })
        };
        store.dispatch(actions.deleteAccountAsync(payload));
    }

    render(){
        if(this.props.userLoggedIn){
            return(
                <div id="container-account" className="menuWrapper">
                    <header>
                        <h2>Account Details</h2>
                    </header>
                    <div className="account-divider">
                        <form>
                            <fieldset>
                                <br/><label>First Name:</label><br/>
                                <input id="ip-firstName" type="text" placeholder={this.props.firstName} onChange={e=>this.updateUserLocalStateData(e, 'firstName')}/>
                                <br/><label>Last Name:</label><br/>
                                <input id="ip-lastName" type="text" placeholder={this.props.lastName} onChange={e=>this.updateUserLocalStateData(e, 'lastName')}/>
                                <br/><label>Gamertag:</label><br/>
                                <input id="ip-gamertag" type="text" placeholder={this.props.gamertag} onChange={e=>this.updateUserLocalStateData(e, 'gamertag')}/>
                                <br/><label>Password:</label><br/>
                                <input id="ip-password" type="text" placeholder={this.props.password} onChange={e=>this.updateUserLocalStateData(e, 'password')}/>
                                <br/><label>Email:</label><br/>
                                <input id="ip-email" type="text" placeholder={this.props.email} onChange={e=>this.updateUserLocalStateData(e, 'email')}/>
                                <br/>
                                <input id="ip-update-account" type="button" value="Update" onClick={e=>this.updateAccount(e)} className="btnColoring" style={{marginTop: "1rem"}}/><br/>
                                <input id="ip-delete-account" type="button" value="Delete Account" onClick={e=>this.deleteAccount(e)} className="btnColoring"/>
                            </fieldset>
                        </form>
                    </div>
                </div>
            );
        }
        else{
            return(
                <Main/>
            );
        }
    }
}

const mapPropsToState = state => ({
    userLoggedIn: state.user.userLoggedIn,
    firstName: state.user.firstName,
    lastName: state.user.lastName,
    gamertag: state.user.gamertag,
    password: state.user.password,
    email: state.user.email
});

export default connect(mapPropsToState)(Account);
export {Account as AccountPure};



// WEBPACK FOOTER //
// ./src/comps/account.js